"use strict";

module.exports = {
  /* SIGHASH Codes
   * Obtained from: https://github.com/ZencashOfficial/zen/blob/master/src/script/interpreter.h
   */
  SIGHASH_ALL: 1,
  SIGHASH_NONE: 2,
  SIGHASH_SINGLE: 3,
  SIGHASH_ANYONECANPAY: 0x80
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/zclassicjs/lib/constants.js
// module id = ./node_modules/zclassicjs/lib/constants.js
// module chunks = 0